import { yup } from '@framework/validation';
import { ExpressionType } from '../../../../expressions/IExpression';
import { IFunctionExpression } from '../../../../expressions/repository/function/IFunctionExpression';
import { IParentWidgetScope } from '../../../IWidgetType';
import { IComputedStringWidget } from '../IComputedWidget';
import { setComputeTransform } from '../setComputedTransform';
import { hydrateComputedString } from './hydrateComputedString';

export function setComputeStringTransform(
  widget: Pick<IComputedStringWidget, 'expression'>,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
) {
  // Costruisco la FunctionExpression così da poter usare
  // le funzionalità di risoluzione già esistenti
  const expression: IFunctionExpression = {
    type: ExpressionType.Function,
    value: widget.expression,
  };

  return setComputeTransform(
    expression,
    parentScope,
    schema,
    (expression: IFunctionExpression, variables: Record<string, any>) => {
      return hydrateComputedString(expression.value.value, variables);
    },
  );
}
